import React, { KeyboardEvent, MouseEvent } from "react";
import styles from "./button.module.scss";
import { ToolTip } from "@components/atoms/tooltip/tooltip";

type ButtonPropTypes = {
  fun: (e: MouseEvent | KeyboardEvent) => void;
  text: string;
  variant?: string | string[];
  disabled?: boolean;
  tooltip?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button = ({
  fun,
  text,
  variant,
  disabled = false,
  tooltip = "",
  children,
  ...rest
}: ButtonPropTypes) => {
  let variantClass = "";

  if (typeof variant === "string") {
    variantClass = styles[`button--${variant}`];
  } else if (Array.isArray(variant)) {
    variantClass = variant.map((v) => styles[`button--${v}`]).join(" ");
  }

  const button = (
    <button
      disabled={disabled}
      onClick={fun}
      className={`
        ${styles.button}
        ${variantClass}
      `}
      {...rest}
    >
      {children ?? text}
    </button>
  );

  return tooltip ? <ToolTip content={tooltip}>{button}</ToolTip> : button;
};
